import React from 'react';
import Create from '../../../containers/rest/Create';
import Form from '../components/Form';

const RolesCreate = props => (
  <Create {...props} resource="roles">
    <Form />
  </Create>
);

RolesCreate.propTypes = {};

export default RolesCreate;
